var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 39.98 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#202b5c;}.cls-4{fill:#46b978;}.cls-5{fill:#688bc7;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-262.27 -100.08)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 262.27,
    y: 100.08,
    width: 39.98,
    height: 40
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CompliancePost") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Compliance_CompliancePost-icon",
    "data-name": "Compliance CompliancePost-icon"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M295.59,101.68a5.08,5.08,0,0,1,5.07,5.07v26.66a5.08,5.08,0,0,1-5.07,5.07H269a5.09,5.09,0,0,1-5.08-5.07V106.75a5.08,5.08,0,0,1,5.08-5.07h26.64m0-1.6H269a6.67,6.67,0,0,0-6.68,6.67v26.66a6.68,6.68,0,0,0,6.68,6.67h26.64a6.67,6.67,0,0,0,6.67-6.67V106.75a6.67,6.67,0,0,0-6.67-6.67",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.75,118.08h-17a.45.45,0,0,1,0-.89h17a.45.45,0,1,1,0,.89",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 12.97,
    y: 17.61,
    width: 0.89,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.28,
    y: 17.55,
    width: 0.89,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 19.58,
    y: 17.55,
    width: 0.89,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 22.89,
    y: 17.55,
    width: 0.89,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 26.19,
    y: 17.61,
    width: 0.89,
    height: 5.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290.75,118.09h-17a.46.46,0,0,1,0-.92h17a.46.46,0,1,1,0,.92",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.69,124a.46.46,0,0,1-.45-.46v-5.83a.45.45,0,0,1,.45-.45.46.46,0,0,1,.46.45v5.83a.47.47,0,0,1-.46.46",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M279,123.91a.46.46,0,0,1-.46-.45v-5.83a.47.47,0,0,1,.46-.46.46.46,0,0,1,.45.46v5.83a.45.45,0,0,1-.45.45",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.3,123.91a.45.45,0,0,1-.45-.45v-5.83a.46.46,0,0,1,.45-.46.47.47,0,0,1,.46.46v5.83a.46.46,0,0,1-.46.45",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.61,123.91a.46.46,0,0,1-.46-.45v-5.83a.47.47,0,0,1,.46-.46.46.46,0,0,1,.45.46v5.83a.45.45,0,0,1-.45.45",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.91,124a.46.46,0,0,1-.45-.46v-5.83a.45.45,0,0,1,.45-.45.46.46,0,0,1,.46.45v5.83a.47.47,0,0,1-.46.46",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M296,132.81H268.56a.45.45,0,0,1-.45-.45.46.46,0,0,1,.45-.46H296a.47.47,0,0,1,.46.46.46.46,0,0,1-.46.45",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M296,125.39H268.56a.46.46,0,0,1,0-.92H296a.46.46,0,0,1,0,.92",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.83,
    y: 24.91,
    width: 0.91,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.24,
    y: 24.85,
    width: 0.91,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.44,
    y: 24.88,
    width: 0.91,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.67,
    y: 24.88,
    width: 0.91,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.89,
    y: 24.88,
    width: 0.91,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.12,
    y: 24.88,
    width: 0.91,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.74,
    y: 24.85,
    width: 0.91,
    height: 5.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31.27,
    y: 24.91,
    width: 0.91,
    height: 5.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.3,109.8a.45.45,0,0,1-.45-.45v-3.77a.46.46,0,0,1,.45-.46.47.47,0,0,1,.46.46v3.77a.46.46,0,0,1-.46.45",
    transform: "translate(-262.27 -100.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.37,116h-.91a6.16,6.16,0,1,0-12.31,0h-.91a7.07,7.07,0,1,1,14.13,0",
    transform: "translate(-262.27 -100.08)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp);
export default __webpack_public_path__ + "static/media/comp.71ddca0b100dad17c3ffb6aaa6c7d064.svg";
export { ForwardRef as ReactComponent };